import PropTypes from 'prop-types';
import React from 'react';
import Markdown from 'react-markdown';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import styles from './InternationalBuyModal.style';

const InternationalBuyModal = ({ actions, appCtx }) => {
  const {
    title = 'Compra Internacional',
    content = '',
    footerLink = 'https://www.falabella.com/falabella-cl/page/compra-internacional',
    modalFooter = 'Para más información, revisa nuestro',
    modalFooterUnderline = 'Centro de ayuda',
  } = appCtx?.siteConfig?.configurations?.internationalShippingModal ?? {};

  React.useEffect(() => {
    actions.setCustomHeader(
      <>
        <div className="modal-header">
          <p className="modal-title">{title}</p>
        </div>
        <style jsx>{styles}</style>
      </>
    );
  }, []);

  return (
    <div className={`modal-container ${!footerLink ? 'hide-footer' : ''}`}>
      <div className="markdown-container">
        <Markdown className="markdown-container">{content}</Markdown>
      </div>
      {footerLink && (
        <div className="rp-modal-footer">
          <div className="divider-line" />
          <div className="footer-wrapper">
            <i className="csicon-alert alertIcon" />
            <p>
              {modalFooter}{' '}
              <a id="testId-help-center-btn" href={footerLink} target="_blank" rel="noopener noreferrer">
                <b>{modalFooterUnderline}</b>.
              </a>
            </p>
          </div>
        </div>
      )}
      <style jsx>{styles}</style>
    </div>
  );
};

InternationalBuyModal.propTypes = {
  actions: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
};

export default withApplicationContext(InternationalBuyModal);
